import { get, isDev } from '@web3/base-utils';
import { getCurrentLocale } from '../i18n';

type Image = {
  url: string;
  uid: string;
};

type Link = {
  href: string;
  title: string;
};

export type Banner = {
  uid: string;
  banner: Array<{
    title: string;
    web_image: Image;
    link: Link;
    project_id: number | null;
  }>;
};

/** CMS的ApiKey */
export const CMS_API_KEY = 'bltf7d2ee46b472a862';

/** CMS的AccessToken */
export const CMS_ACCESS_TOKEN_TEST = 'cs65b620b8eb86994863f4c504';
export const CMS_ACCESS_TOKEN_PROD = 'cs206f84f291ab371e677827c5';

const baseApiUrl = '/spot/api/web3/contentstack/v3/content_types';

const baseparams = () => ({
  locale: getCurrentLocale().toLowerCase(),
  include_fallback: 'true',
  environment: isDev ? 'development' : 'production',
});
const headers = {
  'api-key': CMS_API_KEY,
  'access-token': isDev ? CMS_ACCESS_TOKEN_TEST : CMS_ACCESS_TOKEN_PROD,
};

/** 获取banner列表 */
export const getCmsBanners = () => {
  const params = {
    'only[BASE]': ['banner.link', 'banner.project_id', 'banner.web_image'],
    timestamp: new Date().getTime(),
    ...baseparams(),
  };

  return get<Banner[]>(`${baseApiUrl}/airdrop/entries`, params, headers);
};
